export const queryKeys = {
  authQueryKeys: {
    login: ["login"],
    userDetail: ["USER_PROFILE"],
    forgotPassword: ["FORGOT_PASSWORD"],
    resendOtp: ["RESEND_OTP"],
    verifyOtp: ["VERIFY_OTP"],
    resetPassword: ["RESET_PASSWORD"],
  },
  changePassword: ["CHANGE_PASSWORD"],
  dashboard: {
    stats: "DASHBOARD_STATS",
    revenueGraph: "DASHBOARD_REVENUE_GRAPH",
    userListeningGraph: "DASHBOARD_USER_LISTENING_GRAPH",
    storyMethods: "DASHBOARD_STORY_METHODS",
    voiceClones: "DASHBOARD_VOICE_CLONES",
  },
  userManagement: {
    listing: "USER_LISTING",
    delete: "USER_DELETE",
    statusUpdate: "UPDATE_STATUS",
    details: "USER_DETAILS",
    stats: "USER_STATS",
    profile: "USER_PROFILE",
  },
  lookups: {
    allUsers: "ALL_USERS",
    categories: "CATEGORIES",
    cities: "CITIES",
  },
};
